export const ShareFeedPageSize = 25
export const CopiedFeedPageSize = 25
